import React, { useEffect, useRef, useState } from 'react'
import PaymentMethods from '../../components/CartPage/PaymentInfo/PaymentMethods';
import Timer from '../../components/CartPage/PaymentInfo/Timer'
import Navbar from '../../components/Navbar/Navbar';
import {PaymentPageStyles as styles} from './PaymentPageStyles.tailwind'
import { Alert } from '@mui/material';
import PaymentModal from '../../components/shared/Modals/PaymentModal/PaymentModal';
import { connect, useSelector } from 'react-redux';
import { PAYMENT_STATUS } from '../../lib/constants/globalConstant';
import { useNavigate } from 'react-router-dom';
import routeConstant from '../../lib/constants/routeConstant';
import CommonLoader from '../../components/shared/Loaders/CommonLoader/CommonLoader';
import { setMyAccountActiveTab } from '../../redux/slices/publicSlice';
import { MY_ACCOUNT_TABS } from '../../components/MyAccount/myAccountTabsData';
import CubeLoader from '../../components/shared/Loaders/CubeLoader/CubeLoader';

const EXPIRE_TIME = process.env.REACT_APP_EXPIRE_TIME;
 
const PaymentPage = ({ redirectToMyAccount }) => {
  const paymentRef = useRef(false)
  const navigate = useNavigate();
 
  const { checkoutApiData, checkingOutPayment, updatingPayment } = useSelector((state) => state.cart);
  const checkoutStatus = checkoutApiData?.status // checkout-status TRUE/ FALSE
  const checkoutTimeInMilliSec = checkoutApiData?.checkoutTimeInMilliSec;
  const { cartData } = useSelector((state) => state.cart); // cart-data
 
  const [orderId, setOrderId] = useState(null);
  const [seasonId, setSeasonId] = useState(null);
  const [isModalVisible, setModalVisible] = useState(false); // to open/close modal
  const [paymentStatus, setPaymentStatus] = useState(null);  // to hightlight error or success
  const [paymentIntentLoaded, setPaymentIntentLoaded] = useState({
    paypal: false,
    // venmo: false
  });
 
  const handleCloseModal = async () => {
    setModalVisible(false); // Close modal
    setPaymentStatus(null); // Reset status
    if (paymentStatus === PAYMENT_STATUS.SUCCEDED) {
      redirectToMyAccount();
      navigate(routeConstant.MY_ACCOUNT_PAGE); // Redirect to home or desired path
    }else{
      navigate(routeConstant.CART_PAGE);
    }
  };
 
  const handleOpenModal = async (redirectStatus, orderId, seasonId) => {
    setPaymentStatus(redirectStatus === 'succeeded' ? PAYMENT_STATUS.SUCCEDED : PAYMENT_STATUS.FAILED);
    setOrderId(orderId);
    setSeasonId(seasonId)
    setModalVisible(true);  // open modal
    // window.history.replaceState({}, document.title, window.location.pathname);
  }
 
  // Display modal and set payment status based on URL query params
  useEffect(() => {    
    const queryParams = new URLSearchParams(window.location.search);
   
    const paymentIntent = queryParams.get('payment_intent');   // Payment Intent
    const redirectStatus = queryParams.get('redirect_status'); // Succeeded or Failed
    const orderId = queryParams.get('orderId'); // Order Id
    const seasonId = queryParams.get('seasonId'); // Season Id
   
    // window.history.replaceState({}, document.title, window.location.pathname); [This line is to change route]
    if (paymentIntent) {
      handleOpenModal(redirectStatus, orderId, seasonId);
    }else{
      paymentRef.current = true;
    }
  }, []);
 
  // console.log(checkoutStatus, isModalVisible, updatingPayment, cartData);
  useEffect(() => {
    if(!checkoutStatus && !isModalVisible && !updatingPayment && paymentRef.current && !cartData){
      navigate(routeConstant.CART_PAGE, { replace: true })
    }
  }, [checkoutStatus, isModalVisible, updatingPayment, cartData]);
 
  // const checkIsLoaded = () => {
  //   // if(paymentIntentLoaded.paypal && paymentIntentLoaded.venmo) return true;
  //   if(paymentIntentLoaded.paypal) return true;
  //   return false;
  // }
 
  // show loader
  if(checkingOutPayment || (!checkoutApiData && !orderId)){
    return <CommonLoader />
  }
 
  return (
    <main>
      <Navbar showSeasonDropdown={false} />
 
      {!isModalVisible && (
        <>
          {/* {!checkIsLoaded() && (
            <div className='fixed top-0 left-0 z-[10000] w-screen h-screen bg-themeColor'>
              <CommonLoader />
            </div>
          )} */}
          <section className={styles.wrapper}>
            <div className={styles.wrap_things}>
              <div className={styles.timer_details}>
                {/* Time-Alert */}
                <Alert severity="warning" color="warning" sx={{ backgroundColor: '#191207', color: '#ffe2b7', '.MuiAlert-message': { width: '100%' } }} icon={false}>
                  <div className='flex items-center gap-2 justify-center w-full'>
                    <div>Payment will expires in: </div>
                    <Timer endTime={checkoutTimeInMilliSec + 60000*(EXPIRE_TIME || 5)} />
                  </div>
                </Alert>
              </div>
 
              {/* Payment Cards */}
              <PaymentMethods
                orderId={cartData?._id}
                seasonId={cartData?.seasonId}
                handleOpenModal={handleOpenModal}
                setPaymentIntentLoaded={setPaymentIntentLoaded}
              />
            </div>
          </section>
        </>
      )}
 
      {!checkoutStatus && !isModalVisible && !updatingPayment && (
        <div className='w-full h-full flex items-center justify-center'>
          <CubeLoader />
        </div>
      )}
 
      {isModalVisible && (
        <PaymentModal
          isOpen={isModalVisible}
          onClose={handleCloseModal}
          status={paymentStatus === PAYMENT_STATUS.SUCCEDED ? PAYMENT_STATUS.SUCCEDED : PAYMENT_STATUS.FAILED}
          orderId={orderId}
          seasonId={seasonId}
        />
      )}
    </main>
  )
}
 
const mapDispatchToProps = (dispatch) => {
  return {
    redirectToMyAccount: () => dispatch(setMyAccountActiveTab(MY_ACCOUNT_TABS.DEFAULT_TAB)),
  };
};
 
export default connect(null, mapDispatchToProps)(PaymentPage);
 